import Vue from 'vue';
import axios from 'axios'
export const searchVueApp = new Vue({
	el: '#search-app',
	data: {
		searchVisible: false,
		query: '',
		results: null
	},
	delimiters: ['${', '}'],

	methods: {

		toggleSearch: function() {
			this.searchVisible = ! this.searchVisible;
			this.query = '';

			if (this.searchVisible == true) {
				setTimeout( () => {
					this.$refs.search.focus();
				}, 10);
        this.results = null;
			}

			$('#nav-menu').removeClass('show');

			$('#hamburger').addClass('collapsed');

		},

		getResults: function(query) {
			axios.get('/results?q='+query)
		  .then((response) => {
		    return response.data;
		  }).then((text) => {
				this.results = text;
		  });
		}

	}

});



// WEBPACK FOOTER //
// ./scripts/search-vue-app.js